export enum CreditLedgerEntryType {
  Purchase = 0,
  TopUp = 1,
  Drawdown = 2,
  Adjustment = 3,
  Expiry = 4,
  Refund = 5,
}
